import createSvgIcon from './utils/createSvgIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsx("path", {
  d: "M11.66 6V4H6v5.66h2V7.41l5 5V20h2v-8.41L9.41 6z"
}), 'TurnSlightLeftSharp');